import React from 'react';
import { defaultSort } from './utils/sortOptions';

export default React.createContext({
  searchParams: {
    sportDistances: null,
    minDate: null,
    maxDate: null,
    selectedPopularDateId: null,
    selectedLocation: null,
    geolocation: false,
    locationSearchRadius: null,
    sortOption: defaultSort,
    name: null,
    viewportNorthEastLat: null,
    viewportNorthEastLong: null,
    viewportSouthWestLat: null,
    viewportSouthWestLong: null,
  },

  location: {
    name: null,
    point: null /* { lat, long, radius } */,
    /*
      {
        ne: { lat, lng },
        sw: { lat, lng },
      }
    */
    viewport: null,
    // Indicates whether a user has explicitly set a location.
    isLocationSetByUser: false,
    setPoint: () => {},
    setViewport: () => {},
    currentQs: {},
  },
  sportLabel: null,
  currentPath: null,
  distanceList: [],
  updateQs: () => {},

  setData: () => {},

  tracking: {
    trackButtonClick: () => {},
    trackInputEntered: () => {},
    trackPanelOpen: () => {},
    trackPanelClose: () => {},
    trackGenericEvent: () => {},
  },
});
